import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'gatsby-plugin-react-i18next'
import { Link, CtaContainer, AmazonPrime } from './styles'
import Analytics from '../../utils/Analytics'

const AmazonLink = ({ calendar, link }) => (
  <div>
    <Link
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => Analytics.track('Clicked to Amazon')}
    >
      <CtaContainer calendar={calendar}>
        {/* <ImageContainer>
            <GatsbyImage image={amazon.childImageSharp.gatsbyImageData} alt="Available at Amazon" />
            <GatsbyImage
              image={amazonMobile.childImageSharp.gatsbyImageData}
              alt="Available at Amazon"
            />
          </ImageContainer> */}
        <AmazonPrime>
          <Trans>Shop now at Amazon.com</Trans>
        </AmazonPrime>
      </CtaContainer>
    </Link>
  </div>
)

AmazonLink.propTypes = {
  calendar: PropTypes.bool,
  link: PropTypes.string,
}

export default AmazonLink
